import React, {
  ChangeEvent,
  useCallback,
  useEffect,
  useMemo,
  useState,
  useRef,
} from 'react';
import { FaPuzzlePiece } from 'react-icons/fa6';
import { MdOutlineSwipe } from 'react-icons/md';
import { TbDragDrop2 } from 'react-icons/tb';
import { FaLightbulb } from 'react-icons/fa';
import { getCreator } from 'utils/creator/creator';
import { getCompany } from 'utils/company/companyService';
import { HiLink } from 'react-icons/hi';
import { IoAlert } from 'react-icons/io5';
import { MdPsychology } from 'react-icons/md';
import { FaChartLine } from 'react-icons/fa';
import { FaClipboardList } from 'react-icons/fa';
import { MdAssessment } from 'react-icons/md';
import { MdOutlineAssessment } from 'react-icons/md';
import InputField from 'components/fields/InputField';
import {
  Box,
  Text,
  Flex,
  Checkbox,
  Button,
  Icon,
  List,
  ListItem,
  Img,
  Textarea,
  Input,
  Divider,
  Switch,
  Tooltip,
  SimpleGrid,
} from '@chakra-ui/react';
import Select from 'react-select';
import {
  MdAdd,
  MdCloudUpload,
  MdInbox,
  MdNote,
  MdNoteAdd,
  MdTextsms,
  MdDelete,
  MdOutlineStickyNote2,
} from 'react-icons/md';
import { BiSolidDuplicate } from 'react-icons/bi';
import Menu from '../components/Navigate';
import StrightConector from '../components/dragNdrop/strightConector';

import { TbHandClick, TbMessages } from 'react-icons/tb';
import { FaAward } from 'react-icons/fa6';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@radix-ui/react-tabs';
import { FileText, Layers, Settings } from 'lucide-react';
interface PropsNote {
  formData?: any;
  reviews?: any;
  id?: number;
  language?: any;
  seq?: any;
  index?: number;
  handleNDI?: any;
  name?: any;
  handleInput?: any;
  input?: any;
  getSeq?: any;
  handleMiniNDI?: any;
  duplicateSeq?: any;
  delSeq?: any;
  alphabet?: any;
  setNavigation: any;
  handleBlock: any;
  items?: any;
  formDataGamelanguageCode?: any;
  handleSelectBlock?: any;
  showSelectBlock?: any;
  setSelectBlock?: any;
  validation?: any;
  currentseq?: any;
  ShowReview?: any;
  targetSequence?: any;
  blockOnFocusHanlder: any;
  blockOnBlurHanlder: any;
}
interface Block {
  blockPrimarySequence: string;
  // Add other properties as needed
  content: string | undefined; // Adjust the type according to your data structure
}
interface GameRound {
  id: number;
  // add more fields later if needed
}

interface GameSettings {
  pointsPerCorrect: number;
  timerEnabled: boolean;
  timePerRound: number;
  allowReplay: boolean;
}

interface WehaveChooseConfig {
  title: string;
  subtitle: string;
  characterName: string;
  topicSubtitle: string;
  rounds: GameRound[];
  settings: GameSettings;
}

type OptionField = 'optionText' | 'feedback' | 'guidance' | 'isCorrect';

interface Option {
  optionText: string;
  feedback: string;
  guidance: string;
  isCorrect: boolean;
}

interface Round {
  questionText: string;
  prompt: string;
  options: Option[];
}

const DEFAULT_WEHAVECHOOSE_CONFIG: WehaveChooseConfig = {
  title: '',
  subtitle: '',
  characterName: '',
  topicSubtitle: '',
  rounds: [], // ✅ now typed as GameRound[]
  settings: {
    pointsPerCorrect: 100,
    timerEnabled: false,
    timePerRound: 30,
    allowReplay: false,
  },
};

const WehaveChooseCompo: React.FC<PropsNote> = ({
  formData,
  targetSequence,

  seq,
  index,
  name,
  handleInput,
  input,
  getSeq,
  duplicateSeq,
  delSeq,

  setNavigation,
  handleBlock,
  handleSelectBlock,
  items,

  showSelectBlock,
  handleNDI,

  validation,
}) => {
  console.log('inputssss', input);

  const scenarioOptions = Array.from({ length: 5 }, (_, i) => ({
    label: `Scenario ${i + 1}`,
    value: `Scenario ${i + 1}`,
  }));

  const textareaRef = useRef(null);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [input?.[`WehaveChoose${seq.input}`]?.WehaveChoose]);

  const customButtonStyles = {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '15px',
    borderColor: '#ccc', // Optional: Change border color for disabled state
    borderWidth: '1px', // Add this line to set the border width
    borderStyle: 'solid', // Add this line to set the border style
    cursor: 'not-allowed', // Optional: Change cursor for disabled state
    padding: '5px 10px',
    width: '144px',
    // textAlign: "left",
    outerWidth: '10px',
    outline: 'none',
  };

  const customStyles = {
    menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
    control: (provided: any, state: any) => ({
      ...provided,
      borderRadius: '15px',
      borderColor: 'inherit',
      background: 'transparent',
      // height: '45px',
      width: '130px',
      padding: '0 !important',
    }),
  };

  const handleMiniNDInewblock = (value?: any, seq?: any, i?: any) => {
    handleNDI(value);

    const maxInputItem = items.reduce(
      (max: any, item: any) => (item.input > max.input ? item : max),
      items[0],
    );
    let input = maxInputItem?.input ? maxInputItem.input + 1 : 1;
    if (value !== '') {
      handleSelectBlock(
        { value: input },
        input,
        `WehaveChoose${seq.input}`,
        `WehaveChoose${seq.input}`,
      );
    }
  };
  const [showReflectionQuestions, setShowReflectionQuestions] = useState(false);
  //  const [showScenarioCompletion, setshowScenarioCompletion] = useState(false);
  // const [showWrongAnswer, setShowWrongAnswer] = React.useState(
  //     !!input?.[`WehaveChoose${seq.input}`]?.answerguide
  // );

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    const userId = user?.data?.id;

    console.log('Login user id:', userId);

    if (userId) {
      // First get user details including company ID
      getCreator(userId)
        .then((userResult) => {
          console.log('Complete login user data:', userResult);

          if (userResult?.data?.ctCompanyId) {
            const companyId = userResult.data.ctCompanyId;
            console.log('User company ID:', companyId);

            // Now fetch company details using company ID
            return getCompany(companyId).then((companyResult) => {
              console.log('Company details:', companyResult);

              // Get company name - data is an array, so use [0]
              const companyName = companyResult?.data?.[0]?.cpCompanyName;

              console.log('User belongs to company:', companyName);

              // Now you can use companyName for your logic
              if (companyName?.toLowerCase() === 'cognizant' || 'CTS') {
                setShowReflectionQuestions(true);
                //  setshowScenarioCompletion(true);
              } else {
                setShowReflectionQuestions(false);
                //  setshowScenarioCompletion(false);
              }
            });
          } else {
            console.log('User has no company ID');
            setShowReflectionQuestions(false);
            //  setshowScenarioCompletion(false);
          }
        })
        .catch((error) => {
          console.error('Error fetching user or company details:', error);
          setShowReflectionQuestions(false);
          //  setshowScenarioCompletion(false);
        });
    }
  }, []);
  const MiniBox1 = (props: {
    seq?: any;
    i?: number;
    name?: any;
    bodyRef?: any;
  }) => {
    const { seq, i, name, bodyRef } = props;
    return (
      <Box
        position={'absolute'}
        background={'#fff'}
        p={'10px'}
        boxShadow={'1px 1px 17px #69627914'}
        borderRadius={'8px'}
        zIndex={99}
        className="MiniShowBox"
      >
        <List cursor={'pointer'}>
          <ListItem
            onClick={() => handleMiniNDInewblock('Note', seq, i)}
            p={'10px'}
            display={'flex'}
            alignItems={'center'}
            borderBottom={'2px solid #f1f1f170'}
          >
            <Icon as={MdOutlineStickyNote2} mr={'10px'} color={'#3311db'} />
            Note
          </ListItem>

          <ListItem
            onClick={() => handleMiniNDInewblock('Dialog', seq, i)}
            p={'10px'}
            display={'flex'}
            alignItems={'center'}
            borderBottom={'2px solid #f1f1f170'}
          >
            <Icon as={TbMessages} mr={'10px'} color={'#3311db'} />
            Dialog
          </ListItem>
          <ListItem
            onClick={() => handleMiniNDInewblock('Interaction', seq, i)}
            p={'10px'}
            display={'flex'}
            alignItems={'center'}
          >
            <Icon as={TbHandClick} mr={'10px'} color={'#3311db'} />
            Interaction
          </ListItem>
          <ListItem
            onClick={() => handleMiniNDInewblock('Link', seq, i)}
            p={'10px'}
            display={'flex'}
            alignItems={'center'}
            borderBottom={'2px solid #f1f1f170'}
          >
            <Icon as={HiLink} mr={'10px'} color={'#3311db'} />
            Link
          </ListItem>
          {showReflectionQuestions && (
            <>
              <ListItem
                onClick={() => handleMiniNDInewblock('Reflection', seq, i)}
                p={'10px'}
                display={'flex'}
                alignItems={'center'}
                borderBottom={'2px solid #f1f1f170'}
              >
                <Icon as={MdPsychology} mr={'10px'} color={'#3311db'} />
                Reflection
              </ListItem>
              <ListItem
                onClick={() => handleMiniNDInewblock('Overview', seq, i)}
                p={'10px'}
                display={'flex'}
                alignItems={'center'}
                borderBottom={'2px solid #f1f1f170'}
              >
                <Icon as={FaClipboardList} mr={'10px'} color={'#3311db'} />
                Overview
              </ListItem>
              <ListItem
                onClick={() => handleMiniNDInewblock('KeyInsights', seq, i)}
                p={'10px'}
                display={'flex'}
                alignItems={'center'}
                borderBottom={'2px solid #f1f1f170'}
              >
                <Icon as={FaChartLine} mr={'10px'} color={'#3311db'} />
                KeyInsights
              </ListItem>
              <ListItem
                onClick={() => handleMiniNDInewblock('PreAssessment', seq, i)}
                p={'10px'}
                display={'flex'}
                alignItems={'center'}
                borderBottom={'2px solid #f1f1f170'}
              >
                <Icon as={MdAssessment} mr={'10px'} color={'#3311db'} />
                PreAssessment
              </ListItem>
              <ListItem
                onClick={() => handleMiniNDInewblock('PostAssessment', seq, i)}
                p={'10px'}
                display={'flex'}
                alignItems={'center'}
                borderBottom={'2px solid #f1f1f170'}
              >
                <Icon as={MdOutlineAssessment} mr={'10px'} color={'#3311db'} />
                PostAssessment
              </ListItem>
              <ListItem
                onClick={() => handleMiniNDInewblock('WehaveChoose', seq, i)}
                p={'10px'}
                display={'flex'}
                alignItems={'center'}
                borderBottom={'2px solid #f1f1f170'}
              >
                <Icon as={FaPuzzlePiece} mr={'10px'} color={'#3311db'} />
                WehaveChoose
              </ListItem>
              <ListItem
                onClick={() => handleMiniNDInewblock('SwipeMiniGame', seq, i)}
                p={'10px'}
                display={'flex'}
                alignItems={'center'}
                borderBottom={'2px solid #f1f1f170'}
              >
                <Icon as={MdOutlineSwipe} mr={'10px'} color={'#3311db'} />
                Swipe
              </ListItem>
              <ListItem
                onClick={() => handleMiniNDInewblock('DragForNow', seq, i)}
                p={'10px'}
                display={'flex'}
                alignItems={'center'}
                borderBottom={'2px solid #f1f1f170'}
              >
                <Icon as={TbDragDrop2} mr={'10px'} color={'#3311db'} />
                Drag For Now
              </ListItem>

              {formData?.gameScenarioCompletion === 'true' && (
                <ListItem
                  onClick={() =>
                    handleMiniNDInewblock('ScenarioCompletion', seq, i)
                  }
                  p={'10px'}
                  display={'flex'}
                  alignItems={'center'}
                  borderBottom={'2px solid #f1f1f170'}
                >
                  <Icon as={FaAward} mr={'10px'} color={'#3311db'} />
                  ScenarioCompletion
                </ListItem>
              )}
            </>
          )}
          <ListItem
            onClick={() => handleMiniNDInewblock('WehaveChoose', seq, i)}
            p={'10px'}
            display={'flex'}
            alignItems={'center'}
            borderBottom={'2px solid #f1f1f170'}
          >
            <Icon as={HiLink} mr={'10px'} color={'#3311db'} />
            WehaveChoose
          </ListItem>
        </List>
      </Box>
    );
  };

  const justClick = (event: any, seq: any) => {
    const element = event.target;
    element.focus();
  };

  const createOption = () => ({
    optionText: '',
    feedback: '',
    guidance: '',
    isCorrect: false,
  });

  const createRound = () => ({
    questionText: '',
    prompt: '',
    options: [createOption(), createOption()],
  });

  const [rounds, setRounds] = useState<Round[]>([]);
  const [isHydrated, setIsHydrated] = useState(false);

  const weHaveChoose = input?.[`WehaveChoose${seq.input}`];
  console.log('dfffrff', weHaveChoose);
  const [replayValue, setReplayValue] = useState<'On' | 'Off'>('Off');

  const rangeValue = Number(weHaveChoose?.timer ?? 0);

  const rawTimerEnabled = weHaveChoose?.timerEnabled;

  // normalize EVERYTHING to boolean
  // Backend: 1 = enabled, 0 = disabled, null = disabled
  const timerEnabled =
    rawTimerEnabled === true ||
    rawTimerEnabled === 'true' ||
    rawTimerEnabled === 1 ||
    rawTimerEnabled === '1';

  const normalizedTimerEnabled = timerEnabled;

  const isInitiallyDisabled =
    rawTimerEnabled === false ||
    rawTimerEnabled === 'false' ||
    rawTimerEnabled === 0 ||
    rawTimerEnabled === '0' ||
    rawTimerEnabled == null;

  const [timerUnlocked, setTimerUnlocked] = useState(false);
  const isSwitchDisabled = isInitiallyDisabled && !timerUnlocked;
  const isSwitchChecked = normalizedTimerEnabled;
  const rangeEnabled = normalizedTimerEnabled;

  const rawAnswerGuideEnabled = weHaveChoose?.answerGuideEnabled;

  // normalize EVERYTHING to boolean
  // Backend: 1 = enabled, 0 = disabled, null = disabled
  const isAnswerGuideEnabled =
    rawAnswerGuideEnabled === true ||
    rawAnswerGuideEnabled === 'true' ||
    rawAnswerGuideEnabled === 1 ||
    rawAnswerGuideEnabled === '1';

  useEffect(() => {
    if (
      weHaveChoose?.ShowReplay === 'On' ||
      weHaveChoose?.ShowReplay === 'Off'
    ) {
      setReplayValue(weHaveChoose.ShowReplay);
    }
  }, [weHaveChoose?.ShowReplay]);

  const addRound = () => {
    setRounds((prev) => [...prev, createRound()]);
  };
  type RoundField = 'questionText' | 'prompt';

  const updateRound = (
    roundIndex: number,
    field: RoundField,
    value: string,
  ) => {
    setRounds((prev) => {
      const copy = [...prev];
      copy[roundIndex] = {
        ...copy[roundIndex],
        [field]: value,
      };
      return copy;
    });
  };

  const addOption = (roundIndex: number) => {
    setRounds((prev) => {
      const copy = [...prev];
      if (copy[roundIndex].options.length < 4) {
        copy[roundIndex].options.push(createOption());
      }
      return copy;
    });
  };
  const updateOption = (
    roundIndex: number,
    optionIndex: number,
    field: OptionField,
    value: string | boolean,
  ) => {
    setRounds((prev) => {
      const copy = [...prev];
      copy[roundIndex].options[optionIndex] = {
        ...copy[roundIndex].options[optionIndex],
        [field]: value,
      };
      return copy;
    });
  };

  const setCorrectOption = (roundIndex: number, optionIndex: number) => {
    const copy = [...rounds];
    copy[roundIndex].options = copy[roundIndex].options.map((opt, i) => ({
      ...opt,
      isCorrect: i === optionIndex,
    }));
    setRounds(copy);
  };

  const deleteOption = (roundIndex: number, optionIndex: number) => {
    setRounds((prev) => {
      const copy = [...prev];

      if (copy[roundIndex].options.length <= 2) {
        return copy; // minimum 2 options required
      }

      copy[roundIndex].options = copy[roundIndex].options.filter(
        (_, i) => i !== optionIndex,
      );

      // ensure at least one correct answer exists
      if (!copy[roundIndex].options.some((o) => o.isCorrect)) {
        copy[roundIndex].options[0].isCorrect = true;
      }

      return copy;
    });
  };
  const deleteRound = (roundIndex: number) => {
    setRounds((prev) => {
      if (prev.length <= 1) return prev;
      return prev.filter((_, i) => i !== roundIndex);
    });
  };

  const parseRoundLogicFromDB = (roundLogic: any): Round[] => {
    if (!roundLogic || typeof roundLogic !== 'object') return [createRound()];

    return Object.keys(roundLogic).map((roundKey) => {
      const round = roundLogic[roundKey];

      return {
        questionText: round.questionText || '',
        prompt: round.prompt || '',
        options: Object.keys(round.options || {}).map((optKey) => ({
          optionText: round.options[optKey].optionText || '',
          feedback: round.options[optKey].feedback || '',
          guidance: round.options[optKey].guidance || '',
          isCorrect: !!round.options[optKey].correct,
        })),
      };
    });
  };

  useEffect(() => {
    const blockData = input?.[`WehaveChoose${seq.input}`];
    if (!blockData || isHydrated) return;

    const parsed = safeParseJSON(blockData.roundLogic);

    if (parsed) {
      const uiRounds = convertRoundLogicToRounds(parsed);
      setRounds(uiRounds.length ? uiRounds : [createRound()]);
    } else {
      setRounds([createRound()]);
    }

    setIsHydrated(true);
  }, [input, seq?.input, isHydrated]);

  const buildRoundLogicPayload = (rounds: Round[]) => {
    const roundLogic: any = {};

    rounds.forEach((round, rIndex) => {
      const roundKey = `round${rIndex + 1}`;

      roundLogic[roundKey] = {
        questionText: round.questionText,
        prompt: round.prompt,
        options: {},
      };

      round.options.forEach((opt, oIndex) => {
        const optionKey = String.fromCharCode(65 + oIndex);

        roundLogic[roundKey].options[optionKey] = {
          optionText: opt.optionText,
          feedback: opt.feedback,
          guidance: opt.guidance,
          correct: opt.isCorrect === true,
        };
      });
    });

    return roundLogic;
  };

  useEffect(() => {
    if (!isHydrated) return;

    const payload = buildRoundLogicPayload(rounds);

    handleInput({
      target: {
        name: `WehaveChoose${seq.input}`,
        id: 'roundLogic',
        value: payload,
      },
    });
  }, [rounds, isHydrated]);

  const safeParseJSON = (value: any) => {
    if (!value) return null;

    if (typeof value === 'object') return value;

    if (typeof value === 'string') {
      try {
        return JSON.parse(value);
      } catch (err) {
        console.error('Invalid roundLogic JSON', err);
        return null;
      }
    }

    return null;
  };

  const convertRoundLogicToRounds = (roundLogic: any): Round[] => {
    if (!roundLogic || typeof roundLogic !== 'object') return [];

    return Object.keys(roundLogic).map((roundKey) => {
      const round = roundLogic[roundKey];

      return {
        questionText: round?.questionText ?? '',
        prompt: round?.prompt ?? '',
        options: Object.keys(round?.options || {}).map((optKey) => {
          const opt = round.options[optKey];

          return {
            optionText: opt?.optionText ?? '',
            feedback: opt?.feedback ?? '',
            guidance: opt?.guidance ?? '',
            isCorrect: opt?.correct === true,
          };
        }),
      };
    });
  };
  const backendReplay = weHaveChoose?.ShowReplay;
  // normalize EVERYTHING to boolean
  // Backend: true = enabled, false = disabled, "On"/"Off" = legacy, null = disabled
  const isReplayChecked =
    backendReplay === true ||
    backendReplay === 'On' ||
    backendReplay === 1 ||
    backendReplay === '1';

  return (
    <Flex padding={'10px 0'} alignItems={'start'} overflowY={'hidden'}>
      <Box className="block-action-icons">
        <Tooltip hasArrow label="Choose New Block">
          <div>
            <Icon
              as={MdAdd}
              transitionDelay={'0s !important'}
              fontSize={'18px'}
              color={'grey'}
              mr={'10px'}
              cursor={'pointer'}
              onClick={() => getSeq(seq, index, name)}
            />
          </div>
        </Tooltip>
        <Tooltip hasArrow label="Duplicate">
          <div>
            <Icon
              as={BiSolidDuplicate}
              transitionDelay={'0.1s !important'}
              fontSize={'18px'}
              color={'grey'}
              mr={'10px'}
              cursor={'pointer'}
              onClick={() =>
                duplicateSeq(
                  seq,
                  index,
                  name,
                  input?.[`WehaveChoose${seq.input}`],
                )
              }
            />
          </div>
        </Tooltip>
        <Tooltip hasArrow label="Delete WehaveChoose">
          <div>
            <Icon
              as={MdDelete}
              transitionDelay={'0.2s !important'}
              fontSize={'18px'}
              color={'grey'}
              cursor={'pointer'}
              onClick={() => delSeq(seq, index, name)}
            />
          </div>
        </Tooltip>
      </Box>
      <Box
        className="block-id"
        mr={'10px'}
        w={'50px'}
        fontSize={'17px'}
        color={'#1b2559'}
        fontWeight={'700'}
      >
        {seq.id}
      </Box>

      {/* <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={2} > */}
      <div className="flex w-full flex-1 flex-row self-stretch">
        <Tabs
          defaultValue="general"
          className="flex flex h-full w-full flex-col self-stretch"
        >
          <TabsList className="flex w-full items-center">
            <TabsTrigger
              value="general"
              className="flex flex-1 items-center gap-2 px-4 py-2 text-slate-600 transition-all duration-200 data-[state=active]:rounded-md data-[state=active]:bg-white data-[state=active]:text-slate-900 data-[state=active]:shadow-md"
            >
              <div className="flex flex-1 items-center justify-center gap-2 px-4 py-2">
                <FileText className="h-4 w-4" />
                General Info
              </div>
            </TabsTrigger>
            <TabsTrigger
              value="rounds"
              className="flex flex-1 items-center gap-2 px-4 py-2 text-slate-600 transition-all duration-200 data-[state=active]:rounded-md data-[state=active]:bg-white data-[state=active]:text-slate-900 data-[state=active]:shadow-md"
            >
              <div className="flex flex-1 items-center justify-center gap-2 px-4 py-2">
                <Layers className="h-4 w-4" />
                Rounds & Questions
              </div>
            </TabsTrigger>
            <TabsTrigger
              value="settings"
              className="flex flex-1 items-center gap-2 px-4 py-2 text-slate-600 transition-all duration-200 data-[state=active]:rounded-md data-[state=active]:bg-white data-[state=active]:text-slate-900 data-[state=active]:shadow-md"
            >
              <div className="flex flex-1 items-center justify-center gap-2 px-4 py-2">
                <Settings className="h-4 w-4" />
                Settings
              </div>
            </TabsTrigger>
          </TabsList>

          <TabsContent
            value="general"
            className="mt-[20px] flex flex-col gap-4 self-stretch"
          >
            {/* title */}
            <Box className="title" w="full" display="flex">
              {/* <Text fontSize="13px" fontWeight="600" mb="4px" color="#1b2559">
                        Title
                    </Text> */}

              <input
                placeholder="Title"
                id="MiniTitle"
                className={`${seq.id}`}
                name={`WehaveChoose${seq.input}`}
                onChange={handleInput}
                onClick={(e: any) => justClick(e, seq)}
                value={input?.[`WehaveChoose${seq.input}`]?.MiniTitle || ''}
                style={{
                  overflow: 'hidden',
                  border: validation?.[`WehaveChoose${seq.input}`]
                    ? '2px solid red'
                    : '1px solid #cbd5e1',
                  borderRadius: '8px',
                  padding: '8px 12px',
                  outline: 'none',
                  width: '100%',
                }}
              />
            </Box>
            {/* subtitle */}
            <Box className="block-input-text" w="full" display="flex">
              <textarea
                ref={textareaRef}
                placeholder="MiniSubTitle1"
                id="WehaveChoose"
                className={`${seq.id}`}
                name={`WehaveChoose${seq.input}`}
                onChange={handleInput}
                onClick={(e) => justClick(e, seq)}
                value={input?.[`WehaveChoose${seq.input}`]?.WehaveChoose || ''}
                style={{
                  overflow: 'hidden',
                  border: validation?.[`WehaveChoose${seq.input}`]
                    ? '2px solid red'
                    : '1px solid #cbd5e1', // default border color
                  borderRadius: '8px', // ✅ border radius
                  padding: '8px 12px',
                  outline: 'none',
                  width: '100%',
                }}
                tabIndex={0}
              />
            </Box>

            {/*   Character / Topic */}
            <Box className="Topic flex flex-col" w="full" display="flex">
              <Text fontSize="13px" fontWeight="600" color="#1b2559">
                Character / Topic
              </Text>

              <input
                placeholder="Topic"
                id="MiniTopic"
                className={`${seq.id}`}
                name={`WehaveChoose${seq.input}`}
                onChange={handleInput}
                onClick={(e: any) => justClick(e, seq)}
                value={input?.[`WehaveChoose${seq.input}`]?.MiniTopic || ''}
                style={{
                  overflow: 'hidden',
                  border: validation?.[`WehaveChoose${seq.input}`]
                    ? '2px solid red'
                    : '1px solid #cbd5e1', // default border color
                  borderRadius: '8px', // ✅ border radius
                  padding: '8px 12px',
                  outline: 'none',
                }}
              />
            </Box>

            {/* Character / subtitle */}
            <Box
              className="characterSubtitle flex flex-col"
              w="full"
              display="flex"
            >
              <Text fontSize="13px" fontWeight="600" color="#1b2559">
                Subtitle
              </Text>

              <input
                placeholder="characterSubtitle"
                id="MiniCharacterSubTitle2"
                className={`${seq.id}`}
                name={`WehaveChoose${seq.input}`}
                onChange={handleInput}
                onClick={(e: any) => justClick(e, seq)}
                value={input?.[`WehaveChoose${seq.input}`]?.MiniCharacterSubTitle2 || ''}
                style={{
                  overflow: 'hidden',
                  border: validation?.[`WehaveChoose${seq.input}`]
                    ? '2px solid red'
                    : '1px solid #cbd5e1', // default border color
                  borderRadius: '8px', // ✅ border radius
                  padding: '8px 12px',
                  outline: 'none',
                }}
              />
            </Box>

            {/* scanrio */}
            <Box
              className="scenario-dropdown flex flex-col"
              w="full"
              display="flex"
            >
              <Text fontSize="13px" fontWeight="600" color="#1b2559">
                Select Scenario
              </Text>

              <Select
                placeholder="Select Scenario"
                options={scenarioOptions}
                // value={input?.[`Note${seq.input}`]?.scenario || null}

                value={
                  scenarioOptions.find(
                    (opt) =>
                      opt.value ===
                      input?.[`WehaveChoose${seq.input}`]?.scenario,
                  ) || null
                }
                styles={{
                  ...customStyles,
                  control: (provided: any) => ({
                    ...provided,
                    borderRadius: '8px',
                    minHeight: '36px',
                  }),
                }}
                onChange={(option: any) =>
                  handleInput({
                    name: `WehaveChoose${seq.input}`,
                    value: {
                      // scenario: option,
                      scenario: option?.value,
                    },
                  })
                }
                isSearchable={false}
                menuPortalTarget={document.body}
              />
            </Box>
          </TabsContent>

          <TabsContent
            value="settings"
            className="mt-[20px] flex flex-col gap-4 self-stretch"
          >
            {/* score */}
            <Box className="score" w={{ base: '100%', lg: '200px' }}>
              <Text fontSize="13px" fontWeight="600" mb="4px" color="#1b2559">
                Points per Correct Answer
              </Text>

              <input
                placeholder="Score"
                type="number"
                id="PointsPerCorrectScore"
                className={`${seq.id}`}
                name={`WehaveChoose${seq.input}`}
                onChange={handleInput}
                onClick={(e: any) => justClick(e, seq)}
                value={
                  input?.[`WehaveChoose${seq.input}`]?.PointsPerCorrectScore ||
                  ''
                }
                style={{
                  overflow: 'hidden',
                  border: validation?.[`WehaveChoose${seq.input}`]
                    ? '2px solid red'
                    : '1px solid #cbd5e1', // default border color
                  borderRadius: '8px', // ✅ border radius
                  padding: '8px 12px',
                  outline: 'none',
                }}
              />
            </Box>
            <div className="flex w-full gap-4 self-stretch ">
              {/* correct answer */}
              <Box className="score flex flex-1 flex-col">
                <Text fontSize="13px" fontWeight="600" mb="4px" color="#1b2559">
                  Correct Answer
                </Text>

                <input
                  placeholder="Well Done"
                  id="CorrectAnswerFeedback"
                  className={`${seq.id}`}
                  name={`WehaveChoose${seq.input}`}
                  onChange={handleInput}
                  onClick={(e: any) => justClick(e, seq)}
                  value={
                    input?.[`WehaveChoose${seq.input}`]
                      ?.CorrectAnswerFeedback || ''
                  }
                  style={{
                    overflow: 'hidden',
                    border: validation?.[`WehaveChoose${seq.input}`]
                      ? '2px solid red'
                      : '1px solid #cbd5e1', // default border color
                    borderRadius: '8px', // ✅ border radius
                    padding: '8px 12px',
                    outline: 'none',
                  }}
                />
              </Box>
              {/* wrong answer */}
              <Box className="score flex flex-1 flex-col">
                <Text fontSize="13px" fontWeight="600" mb="4px" color="#1b2559">
                  Wrong Answer
                </Text>

                <input
                  placeholder="Not Yet"
                  id="WrongAnswerFeedback"
                  className={`${seq.id}`}
                  name={`WehaveChoose${seq.input}`}
                  onChange={handleInput}
                  onClick={(e: any) => justClick(e, seq)}
                  value={
                    input?.[`WehaveChoose${seq.input}`]?.WrongAnswerFeedback ||
                    ''
                  }
                  style={{
                    overflow: 'hidden',
                    border: validation?.[`WehaveChoose${seq.input}`]
                      ? '2px solid red'
                      : '1px solid #cbd5e1', // default border color
                    borderRadius: '8px', // ✅ border radius
                    padding: '8px 12px',
                    outline: 'none',
                  }}
                />
              </Box>
            </div>

            {/* <Switch
                            checked={showWrongAnswer}
                            onChange={(e) => handleToggle(e.target.checked)}
                        /> */}

            {/* input box */}
            {/* <div className="mb-2 w-full lg:w-[200px]"> */}

            {/* Label + Switch */}
            <div className="flex items-center justify-between ">
              <p className="text-[13px] font-semibold text-[#1b2559]">
                Answer Guidance
              </p>
              <Switch
                isChecked={isAnswerGuideEnabled}
                className="mr-[10px]"
                onChange={(e) =>
                  handleInput({
                    target: {
                      id: 'answerGuideEnabled',
                      name: `WehaveChoose${seq.input}`,
                      value: e.target.checked,
                    },
                  })
                }
              />
            </div>

            {/* Input (conditionally shown) */}
            {isAnswerGuideEnabled && (
              <input
                placeholder="Answer guidance"
                id="AnswerGuide"
                name={`WehaveChoose${seq.input}`}
                value={weHaveChoose?.AnswerGuide || ''}
                style={{
                  overflow: 'hidden',
                  border: validation?.[`WehaveChoose${seq.input}`]
                    ? '2px solid red'
                    : '1px solid #cbd5e1',
                  borderRadius: '8px',
                  padding: '8px 12px',
                  outline: 'none',
                }}
                onChange={(e) =>
                  handleInput({
                    target: {
                      id: 'AnswerGuide',
                      name: `WehaveChoose${seq.input}`,
                      value: e.target.value,
                    },
                  })
                }
                onClick={(e: any) => justClick(e, seq)}
                className={`${
                  seq.id
                } w-full rounded-lg border px-3 py-2 text-sm outline-none ${
                  validation?.[`WehaveChoose${seq.input}`]
                    ? 'border-red-500'
                    : 'border-slate-300'
                }`}
              />
            )}
            {/* </div> */}

            {/* range meter */}
            {/* <div className="mb-2 w-full lg:w-[200px]"> */}

            {/* Label + Switch */}
            <div
              className="flex items-center justify-between "
              onClick={() => {
                // unlock on first interaction
                if (isSwitchDisabled) {
                  setTimerUnlocked(true);

                  handleInput({
                    target: {
                      id: 'timerEnabled',
                      name: `WehaveChoose${seq.input}`,
                      value: true, // first enable
                    },
                  });
                }
              }}
            >
              <div className="flex items-center gap-4">
                <p className="text-[13px] font-semibold text-[#1b2559]">
                  Range Selector
                </p>
                {/* Optional value display */}
                {rangeEnabled && (
                  <p className="text-muted-foreground text-right text-xs">
                    {input?.[`WehaveChoose${seq.input}`]?.Timerlimit ?? 0}
                  </p>
                )}
              </div>
              <Switch
                isChecked={isSwitchChecked}
                isDisabled={isSwitchDisabled}
                className="mr-[10px]"
                pointerEvents={isSwitchDisabled ? 'none' : 'auto'}
                onChange={(e) =>
                  handleInput({
                    target: {
                      id: 'timerEnabled',
                      name: `WehaveChoose${seq.input}`,
                      value: e.target.checked, // boolean
                    },
                  })
                }
              />
            </div>

            {/* Range Slider */}
            {rangeEnabled && (
              <div className="w-full space-y-1 ">
                <input
                  type="range"
                  min={0}
                  max={120}
                  className="flex w-full flex-1"
                  value={Number(weHaveChoose?.Timerlimit ?? 0)}
                  onChange={(e) =>
                    handleInput({
                      target: {
                        id: 'Timerlimit',
                        name: `WehaveChoose${seq.input}`,
                        value: Number(e.target.value),
                      },
                    })
                  }
                />
              </div>
            )}
            {/* </div> */}

            {/* replay */}
            {/* <div className="mb-2 w-full lg:w-[200px]"> */}
            <div className="flex items-center justify-between ">
              <p className="text-[13px] font-semibold text-[#1b2559]">
                Allow Replay
              </p>
              <div className="flex gap-3">
                <Text
                  fontSize="12px"
                  fontWeight="600"
                  color={isReplayChecked ? 'green.500' : 'red.500'}
                >
                  {isReplayChecked ? 'Replay Enabled' : 'Replay Disabled'}
                </Text>
                <Switch
                  id="ShowReplay"
                  isChecked={
                    weHaveChoose?.ShowReplay === true ||
                    weHaveChoose?.ShowReplay === 1
                  }
                  className="mr-[10px]"
                  onChange={(e) => {
                    handleInput({
                      target: {
                        name: `WehaveChoose${seq.input}`,
                        id: 'ShowReplay',
                        value: e.target.checked,
                      },
                    });
                  }}
                />
              </div>
            </div>
            {/* </div> */}

            {/* congratulation message */}
            {/* wrong answer */}
            {/* low score */}
            <div className="flex flex-col gap-3">
              <Text fontSize="13px" fontWeight="600" color="#1b2559">
                Congratulatory Message
              </Text>
              <Box className="score flex flex-col gap-2">
                <Text fontSize="13px" fontWeight="600" color="#1b2559">
                  Low Score
                </Text>

                <div className="flex gap-4">
                  <div className="flex flex-1 flex-col">
                    <Text fontSize="13px" fontWeight="600" color="#1b2559">
                      Min %
                    </Text>

                    <input
                      placeholder="Min Score"
                      type="number"
                      id="Minlowscore"
                      className={`${seq.id}`}
                      name={`WehaveChoose${seq.input}`}
                      onChange={handleInput}
                      onClick={(e: any) => justClick(e, seq)}
                      value={
                        input?.[`WehaveChoose${seq.input}`]?.Minlowscore || ''
                      }
                      style={{
                        overflow: 'hidden',
                        border: validation?.[`WehaveChoose${seq.input}`]
                          ? '2px solid red'
                          : '1px solid #cbd5e1',
                        borderRadius: '8px',
                        padding: '8px 12px',
                        outline: 'none',
                      }}
                    />
                  </div>
                  <div className="flex flex-1 flex-col">
                    <Text fontSize="13px" fontWeight="600" color="#1b2559">
                      Max %
                    </Text>

                    <input
                      placeholder="Max Score"
                      type="number"
                      id="Maxlowscore"
                      className={`${seq.id}`}
                      name={`WehaveChoose${seq.input}`}
                      onChange={handleInput}
                      onClick={(e: any) => justClick(e, seq)}
                      value={
                        input?.[`WehaveChoose${seq.input}`]?.Maxlowscore || ''
                      }
                      style={{
                        overflow: 'hidden',
                        border: validation?.[`WehaveChoose${seq.input}`]
                          ? '2px solid red'
                          : '1px solid #cbd5e1',
                        borderRadius: '8px',
                        padding: '8px 12px',
                        outline: 'none',
                      }}
                    />
                  </div>
                </div>

                <div className="flex w-full flex-1 flex-col">
                  <Text fontSize="13px" fontWeight="600" color="#1b2559">
                    Message
                  </Text>

                  <input
                    placeholder="Message"
                    id="LowScoreMessage"
                    className={`${seq.id}`}
                    name={`WehaveChoose${seq.input}`}
                    onChange={handleInput}
                    onClick={(e: any) => justClick(e, seq)}
                    value={
                      input?.[`WehaveChoose${seq.input}`]?.LowScoreMessage || ''
                    }
                    style={{
                      overflow: 'hidden',
                      border: validation?.[`WehaveChoose${seq.input}`]
                        ? '2px solid red'
                        : '1px solid #cbd5e1', // default border color
                      borderRadius: '8px', // ✅ border radius
                      padding: '8px 12px',
                      outline: 'none',
                    }}
                  />
                </div>
              </Box>

              {/* medium Score */}
              <Box className="score flex flex-col gap-2">
                <Text fontSize="13px" fontWeight="600" color="#1b2559">
                  Medium Score
                </Text>

                <div className="flex gap-4">
                  <div className="flex flex-1 flex-col">
                    <Text fontSize="13px" fontWeight="600" color="#1b2559">
                      Min %
                    </Text>

                    <input
                      placeholder="Min Score"
                      id="Minmediumscore"
                      type="number"
                      className={`${seq.id}`}
                      name={`WehaveChoose${seq.input}`}
                      onChange={handleInput}
                      onClick={(e: any) => justClick(e, seq)}
                      value={
                        input?.[`WehaveChoose${seq.input}`]?.Minmediumscore ||
                        ''
                      }
                      style={{
                        overflow: 'hidden',
                        border: validation?.[`WehaveChoose${seq.input}`]
                          ? '2px solid red'
                          : '1px solid #cbd5e1',
                        borderRadius: '8px',
                        padding: '8px 12px',
                        outline: 'none',
                      }}
                    />
                  </div>
                  <div className="flex flex-1 flex-col">
                    <Text fontSize="13px" fontWeight="600" color="#1b2559">
                      Max %
                    </Text>

                    <input
                      type="number"
                      placeholder="Max Score"
                      id="Maxmediumscore"
                      className={`${seq.id}`}
                      name={`WehaveChoose${seq.input}`}
                      onChange={handleInput}
                      onClick={(e: any) => justClick(e, seq)}
                      value={
                        input?.[`WehaveChoose${seq.input}`]?.Maxmediumscore ||
                        ''
                      }
                      style={{
                        overflow: 'hidden',
                        border: validation?.[`WehaveChoose${seq.input}`]
                          ? '2px solid red'
                          : '1px solid #cbd5e1',
                        borderRadius: '8px',
                        padding: '8px 12px',
                        outline: 'none',
                      }}
                    />
                  </div>
                </div>

                <div className="flex w-full flex-1 flex-col">
                  <Text fontSize="13px" fontWeight="600" color="#1b2559">
                    Message
                  </Text>

                  <input
                    placeholder="Message"
                    id="MediumScoreMessage"
                    className={`${seq.id}`}
                    name={`WehaveChoose${seq.input}`}
                    onChange={handleInput}
                    onClick={(e: any) => justClick(e, seq)}
                    value={
                      input?.[`WehaveChoose${seq.input}`]?.MediumScoreMessage ||
                      ''
                    }
                    style={{
                      overflow: 'hidden',
                      border: validation?.[`WehaveChoose${seq.input}`]
                        ? '2px solid red'
                        : '1px solid #cbd5e1', // default border color
                      borderRadius: '8px', // ✅ border radius
                      padding: '8px 12px',
                      outline: 'none',
                    }}
                  />
                </div>
              </Box>
              {/* High Score */}
              <Box className="score flex flex-col gap-2">
                <Text fontSize="13px" fontWeight="600" color="#1b2559">
                  High Score
                </Text>
                <div className="flex gap-4">
                  <div className="flex flex-1 flex-col">
                    <Text fontSize="13px" fontWeight="600" color="#1b2559">
                      Min %
                    </Text>

                    <input
                      placeholder="Min Score"
                      type="number"
                      id="Minhighscore"
                      className={`${seq.id}`}
                      name={`WehaveChoose${seq.input}`}
                      onChange={handleInput}
                      onClick={(e: any) => justClick(e, seq)}
                      value={
                        input?.[`WehaveChoose${seq.input}`]?.Minhighscore || ''
                      }
                      style={{
                        overflow: 'hidden',
                        border: validation?.[`WehaveChoose${seq.input}`]
                          ? '2px solid red'
                          : '1px solid #cbd5e1',
                        borderRadius: '8px',
                        padding: '8px 12px',
                        outline: 'none',
                      }}
                    />
                  </div>
                  <div className="flex flex-1 flex-col">
                    <Text fontSize="13px" fontWeight="600" color="#1b2559">
                      Max %
                    </Text>

                    <input
                      placeholder="Max Score"
                      type="number"
                      id="Maxhighscore"
                      className={`${seq.id}`}
                      name={`WehaveChoose${seq.input}`}
                      onChange={handleInput}
                      onClick={(e: any) => justClick(e, seq)}
                      value={
                        input?.[`WehaveChoose${seq.input}`]?.Maxhighscore || ''
                      }
                      style={{
                        overflow: 'hidden',
                        border: validation?.[`WehaveChoose${seq.input}`]
                          ? '2px solid red'
                          : '1px solid #cbd5e1',
                        borderRadius: '8px',
                        padding: '8px 12px',
                        outline: 'none',
                      }}
                    />
                  </div>
                </div>
                <div className="flex w-full flex-1 flex-col">
                  <Text fontSize="13px" fontWeight="600" color="#1b2559">
                    Message
                  </Text>

                  <input
                    placeholder="Message"
                    id="highScoreMessage"
                    className={`${seq.id}`}
                    name={`WehaveChoose${seq.input}`}
                    onChange={handleInput}
                    onClick={(e: any) => justClick(e, seq)}
                    value={
                      input?.[`WehaveChoose${seq.input}`]?.highScoreMessage ||
                      ''
                    }
                    style={{
                      overflow: 'hidden',
                      border: validation?.[`WehaveChoose${seq.input}`]
                        ? '2px solid red'
                        : '1px solid #cbd5e1', // default border color
                      borderRadius: '8px', // ✅ border radius
                      padding: '8px 12px',
                      outline: 'none',
                    }}
                  />
                </div>
              </Box>
            </div>
          </TabsContent>
          {/* ================= ROUNDS LOGIC ================= */}
          <TabsContent
            value="rounds"
            className="mt-[20px] flex flex-col gap-4 self-stretch"
          >
            <Box>
              <Flex justify="space-between" align="center" mb={4}>
                <Text fontSize="16px" fontWeight="700">
                  Rounds ({rounds.length})
                </Text>

                <Button size="sm" colorScheme="blue" onClick={addRound}>
                  + Add Round
                </Button>
              </Flex>

              {rounds.map((round, rIndex) => (
                <Box
                  key={rIndex}
                  border="1px solid #e2e8f0"
                  borderRadius="10px"
                  p={4}
                  mb={5}
                >
                  <Flex justify="space-between" align="center" mb={3}>
                    <Text fontWeight="600">Round {rIndex + 1}</Text>

                    <Button
                      size="xs"
                      colorScheme="red"
                      variant="outline"
                      onClick={() => deleteRound(rIndex)}
                      isDisabled={rounds.length === 1}
                    >
                      Delete Round
                    </Button>
                  </Flex>

                  {/* Question Text */}
                  <Box mb={3}>
                    <Text fontSize="13px" fontWeight="600" mb="4px">
                      Question Text
                    </Text>
                    <textarea
                      value={round.questionText}
                      onChange={(e) =>
                        updateRound(rIndex, 'questionText', e.target.value)
                      }
                      className="w-full rounded-lg border px-3 py-2"
                      placeholder="e.g. Goal: By the end of this quarter, I will achieve 30%..."
                      style={{
                        overflow: 'hidden',
                        border: validation?.[`WehaveChoose${seq.input}`]
                          ? '2px solid red'
                          : '1px solid #cbd5e1',
                        borderRadius: '8px',
                        padding: '8px 12px',
                        outline: 'none',
                      }}
                    />
                  </Box>

                  {/* Prompt */}
                  <Box mb={4}>
                    <Text fontSize="13px" fontWeight="600" mb="4px">
                      Prompt (Optional)
                    </Text>
                    <input
                      value={round.prompt}
                      onChange={(e) =>
                        updateRound(rIndex, 'prompt', e.target.value)
                      }
                      className="w-full rounded-lg border px-3 py-2"
                      placeholder="e.g. Is anything amiss in this goal?"
                      style={{
                        overflow: 'hidden',
                        border: validation?.[`WehaveChoose${seq.input}`]
                          ? '2px solid red'
                          : '1px solid #cbd5e1',
                        borderRadius: '8px',
                        padding: '8px 12px',
                        outline: 'none',
                      }}
                    />
                  </Box>

                  {/* Options */}
                  <Text fontSize="13px" fontWeight="600" mb={2}>
                    Answer Options ({round.options.length}/4)
                  </Text>

                  {round.options.map((opt, oIndex) => (
                    <Box
                      key={oIndex}
                      border="1px dashed #cbd5e1"
                      borderRadius="8px"
                      p={3}
                      mb={3}
                    >
                      <Flex justify="space-between" align="center" mb={2}>
                        <Text fontWeight="600">
                          Option {String.fromCharCode(65 + oIndex)}
                        </Text>

                        <Flex gap={2} align="center">
                          <Checkbox
                            isChecked={opt.isCorrect}
                            onChange={() => setCorrectOption(rIndex, oIndex)}
                          >
                            Correct
                          </Checkbox>

                          <Button
                            size="xs"
                            colorScheme="red"
                            variant="ghost"
                            onClick={() => deleteOption(rIndex, oIndex)}
                            isDisabled={round.options.length <= 2}
                          >
                            Delete
                          </Button>
                        </Flex>
                      </Flex>

                      {/* Option Text */}
                      <input
                        className="mb-2 mt-2 w-full rounded-lg border px-3 py-2"
                        placeholder="Option text"
                        value={opt.optionText}
                        onChange={(e) =>
                          updateOption(
                            rIndex,
                            oIndex,
                            'optionText',
                            e.target.value,
                          )
                        }
                        style={{
                          overflow: 'hidden',
                          border: validation?.[`WehaveChoose${seq.input}`]
                            ? '2px solid red'
                            : '1px solid #cbd5e1',
                          borderRadius: '8px',
                          padding: '8px 12px',
                          outline: 'none',
                        }}
                      />

                      {/* Feedback */}
                      <Text
                        fontWeight="600"
                        style={{
                          marginTop: '10px',
                        }}
                      >
                        Feedback
                      </Text>
                      <textarea
                        className="mb-2 mt-3 w-full rounded-lg border px-3 py-2"
                        placeholder="Explanation for right / wrong"
                        value={opt.feedback}
                        onChange={(e) =>
                          updateOption(
                            rIndex,
                            oIndex,
                            'feedback',
                            e.target.value,
                          )
                        }
                        style={{
                          overflow: 'hidden',
                          border: validation?.[`WehaveChoose${seq.input}`]
                            ? '2px solid red'
                            : '1px solid #cbd5e1',
                          borderRadius: '8px',
                          padding: '8px 12px',
                          outline: 'none',
                          marginTop: '10px',
                        }}
                      />

                      {/* Guidance */}
                      <input
                        className="w-full rounded-lg border px-3 py-2"
                        placeholder="Better alternative or ideal answer "
                        value={opt.guidance}
                        onChange={(e) =>
                          updateOption(
                            rIndex,
                            oIndex,
                            'guidance',
                            e.target.value,
                          )
                        }
                        style={{
                          overflow: 'hidden',
                          border: validation?.[`WehaveChoose${seq.input}`]
                            ? '2px solid red'
                            : '1px solid #cbd5e1',
                          borderRadius: '8px',
                          padding: '8px 12px',
                          outline: 'none',
                          marginTop: '15px',
                        }}
                      />
                    </Box>
                  ))}

                  {/* Add Option */}
                  {round.options.length < 4 && (
                    <Button
                      size="sm"
                      variant="outline"
                      onClick={() => addOption(rIndex)}
                    >
                      + Add Option
                    </Button>
                  )}
                </Box>
              ))}
            </Box>
          </TabsContent>

          {/* navigation */}
          <Box
            className="navigation-icon items-center justify-center"
            display={'flex'}
            alignItems={'center'}
            mt={'20px'}
            width={'auto'}
          >
            <Flex>
              <Box>
                <Tooltip hasArrow label="Add Navigations">
                  <div>
                    <Menu
                      tabState={'leadDialog'}
                      id={seq.input}
                      for={`WehaveChoose${seq.input}`}
                      setNavigation={setNavigation}
                      handleBlock={handleBlock}
                      items={items}
                      seq={seq}
                    />
                  </div>
                </Tooltip>
              </Box>
              <Box
                ml={'4px'}
                cursor={'pointer'}
                display={
                  input?.[`WehaveChoose${seq.input}`]?.WehaveChooseleadShow
                    ? 'block'
                    : 'none'
                }
                zIndex={9999}
              >
                {input?.[`WehaveChoose${seq.input}`]?.WehaveChooseleadShow ===
                  'New Block' &&
                !input?.[`WehaveChoose${seq.input}`]?.WehaveChoosenavigate ? (
                  // Render content for New Block
                  <>
                    <MiniBox1 seq={seq} i={index} />
                  </>
                ) : input?.[`WehaveChoose${seq.input}`]
                    ?.WehaveChooseleadShow === 'Select Block' &&
                  !input?.[`WehaveChoose${seq.input}`]?.WehaveChoosenavigate ? (
                  // Render select tag for Select Block
                  <Select
                    placeholder={'Blocks...'}
                    id="Dialog"
                    name={`WehaveChoose${seq.input}`}
                    menuPortalTarget={document.body}
                    styles={customStyles}
                    options={showSelectBlock.filter(
                      (option: any) => option.value !== seq.input,
                    )}
                    isSearchable={true}
                    className="react-select"
                    value={
                      showSelectBlock.find(
                        (option: any) =>
                          option.value ==
                          input?.[`WehaveChoose${seq.input}`]
                            ?.WehaveChoosenavigate,
                      ) || null
                    }
                    onChange={(e: any) =>
                      handleSelectBlock(
                        e,
                        seq.input,
                        `WehaveChoose${seq.input}`,
                        `WehaveChoose${seq.input}`,
                      )
                    }
                  />
                ) : (
                  // Render content for the 'else' condition
                  <>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <StrightConector
                        name={
                          input?.[`WehaveChoose${seq.input}`]
                            ?.WehaveChooseleadShow === 'New Block'
                            ? showSelectBlock.find(
                                (option: any) =>
                                  option.value ==
                                  input?.[`WehaveChoose${seq.input}`]
                                    ?.WehaveChoosenavigate,
                              )?.label
                            : input?.[`WehaveChoose${seq.input}`]
                                ?.WehaveChooseleadShow === 'Select Block'
                            ? showSelectBlock.find(
                                (option: any) =>
                                  option.value ==
                                  input?.[`WehaveChoose${seq.input}`]
                                    ?.WehaveChoosenavigate,
                              )?.label
                            : input?.[`WehaveChoose${seq.input}`]
                                ?.WehaveChoosenavigate
                        }
                      />
                    </div>
                  </>
                )}
              </Box>
            </Flex>
          </Box>
          {/* </SimpleGrid> */}
        </Tabs>
      </div>
    </Flex>
  );
};

export default WehaveChooseCompo;
